import {
  WHITE,
  SOY,
  MEDIUM_SOY,
  NO_OPACITY_WHITE,
  ERROR
} from 'styles/theme/colors';

import {
  FONT_PRESET_MAP,
  DEFAULT_LETTER_SPACING,
  HEADER_AND_NAVIGATION_LETTER_SPACING
} from 'styles/theme/constants';

const getHeaderDefaultFontPreset = fontpreset =>
  !fontpreset || fontpreset === 'none'
    ? FONT_PRESET_MAP.circular_std_medium
    : fontpreset;

export function getButtonColorsWithDefaults({
  button_font_color,
  button_background_color,
  button_hover_font_color,
  button_hover_background_color
}) {
  return {
    button_font_color: button_font_color || WHITE,
    button_background_color: button_background_color || SOY,
    button_hover_font_color: button_hover_font_color || WHITE,
    button_hover_background_color: button_hover_background_color || MEDIUM_SOY
  };
}

export function getCardAndBackgroundColorsWithDefaults({
  card_background_color,
  card_outline_color,
  page_background_color,
  drop_shadow
}) {
  return {
    card_background_color: card_background_color || WHITE,
    card_outline_color: card_outline_color || NO_OPACITY_WHITE,
    page_background_color: page_background_color || WHITE,
    drop_shadow: drop_shadow ?? true
  };
}

export function getHeaderAndNavigationWithDefaults({
  accent_color,
  header_background_color,
  header_link_color,
  header_link_hover_color,
  section_navigation_link_color,
  section_navigation_link_hover_color,
  letter_spacing,
  fontpreset,
  weight,
  uppercase,
  font
}) {
  return {
    accent_color: accent_color || MEDIUM_SOY,
    header_background_color: header_background_color || WHITE,
    header_link_color: header_link_color || SOY,
    header_link_hover_color: header_link_hover_color || MEDIUM_SOY,
    section_navigation_link_color: section_navigation_link_color || SOY,
    section_navigation_link_hover_color:
      section_navigation_link_hover_color || MEDIUM_SOY,
    letter_spacing: letter_spacing || HEADER_AND_NAVIGATION_LETTER_SPACING,
    fontpreset: getHeaderDefaultFontPreset(fontpreset),
    weight: weight || 500,
    uppercase: uppercase || false,
    font: font || ''
  };
}

export function getItemDescriptionsAndPricesWithDefaults({
  fontpreset,
  letter_spacing,
  weight,
  italics,
  font
}) {
  return {
    fontpreset:
      !fontpreset || fontpreset === 'none'
        ? FONT_PRESET_MAP.circular_std_book
        : fontpreset,
    letter_spacing: letter_spacing || DEFAULT_LETTER_SPACING,
    weight: weight || 400,
    italics: italics || false,
    font: font || ''
  };
}

export function getMenuItemNamesWithDefaults({
  fontpreset,
  letter_spacing,
  weight,
  color,
  uppercase,
  font
}) {
  return {
    fontpreset: getHeaderDefaultFontPreset(fontpreset),
    letter_spacing: letter_spacing || DEFAULT_LETTER_SPACING,
    weight: weight || 500,
    uppercase: uppercase || false,
    font: font || '',
    color: color || SOY
  };
}

export function getMenuSectionTitlesWithDefaults({
  fontpreset,
  letter_spacing,
  weight,
  color,
  uppercase,
  font,
  size
}) {
  return {
    fontpreset: getHeaderDefaultFontPreset(fontpreset),
    letter_spacing: letter_spacing || DEFAULT_LETTER_SPACING,
    weight: weight || 500,
    uppercase: uppercase || false,
    font: font || '',
    color: color || SOY,
    size: size || '20px'
  };
}

export function getErrorStatesWithDefaults({ error_color }) {
  return {
    error_color: error_color || ERROR
  };
}
